import React from 'react';

import { forwardRef, rem, StyleProps, Wrap } from '@bonusly/design-system';

import { useHomepageRedesignEnabled } from '../../../modules/bonus-feed/features/recognition/components/BonusFeed/hooks/useHomepageRedesignEnabled';
import { useIsEnabled } from '../hooks/use-is-enabled';
import { AmountButton } from './tags';
import { HashtagButton } from './tags/hashtag-button';
import { RecipientButton } from './tags/recipient-button';

export type ActionTagsProps = StyleProps;

/**
 * The top level primary tags for easily adding recipient, amount, and hashtag to an input
 */
export const ActionTags = forwardRef((props: ActionTagsProps, ref) => {
	const showAmountButton = useIsEnabled('amount');
	const isHomepageRedesignEnabled = useHomepageRedesignEnabled();

	const spacing = isHomepageRedesignEnabled ? rem(7) : { base: 0, '2xs': 3 };

	return (
		<Wrap {...props} spacing={spacing} ref={ref}>
			<RecipientButton />
			{showAmountButton && <AmountButton />}
			<HashtagButton />
		</Wrap>
	);
});

ActionTags.displayName = 'ActionTags';
